import { AsyncAjaxDelete } from "components/Common/AsyncAjaxService"
import { DefaultSiteData } from "components/WebDesigner/Data/SiteData"
import { setNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode"
import { UserContext } from "vagaro-website-rendering/src/components/Definitions/UserContext"
import { AsyncAjaxGet, AsyncAjaxPost } from "vagaro-website-rendering/src/components/Utilities/AsyncAjaxService"
import {ValidateToken} from "vagaro-website-rendering/src/components/Utilities/BusinessData"
type VagaroSetLibraryAPI = {

    getList :string,
    add :string,
    delete :string,
    edit :string,
    setPrivate :string,
    setPublic :string,
    getCategories: string,
    editItemsCategories: string,
    addEditCategory: string,
    deleteCategory: string,
    changeSequence: string,
    getDetails: string
}



export enum SetType {
    Font = "Font",
    Color = "Color",
    Image = "Image",
    

}

 const FontSetApi:VagaroSetLibraryAPI = {
    getList : "Isolating/font/list",

    add : "Isolating/font/add",
    delete : "Isolating/font/delete",
    edit : "Isolating/font/edit",
    setPrivate : "Isolating/font/private",
    setPublic : "Isolating/font/public",
    editItemsCategories: "Isolating/font/editcategory",
    getCategories: "Isolating/font/category",
    addEditCategory: "Isolating/font/addeditcategory",
    deleteCategory: "Isolating/font/deletecategory",
    getDetails: "Isolating/font/",
    changeSequence: "Isolating/font/changesquance",
 



}

 const ColorSetApi:VagaroSetLibraryAPI = {
    getList : "Isolating/color/list",
    getDetails: "Isolating/color/",
    add : "Isolating/color/add",
    delete : "Isolating/color/delete",
    edit : "Isolating/color/edit",
    setPrivate : "Isolating/color/private",
    setPublic : "Isolating/color/public",
    getCategories: "Isolating/color/category",
    addEditCategory: "Isolating/color/addeditcategory",
    deleteCategory: "Isolating/color/deletecategory",
    changeSequence: "Isolating/color/changesquance",
    editItemsCategories: "Isolating/color/editcategory",
}

 const ImageSetApi:VagaroSetLibraryAPI = {
    getDetails: "Isolating/image/",
    getList : "Isolating/image/list",
    add : "Isolating/image/add",
    delete : "Isolating/image/delete",
    edit : "Isolating/image/edit",
    setPrivate : "Isolating/image/private",
    setPublic : "Isolating/image/public",
    getCategories: "Isolating/image/category",
    addEditCategory: "Isolating/image/addeditcategory",
    deleteCategory: "Isolating/image/deletecategory",
    changeSequence: "Isolating/image/changesquance",
    editItemsCategories: "Isolating/image/editcategory",

}

function GetSetApi(type:SetType):VagaroSetLibraryAPI{
    switch(type){
        case SetType.Font:
            return FontSetApi;
        case SetType.Color:
            return ColorSetApi;
        case SetType.Image:
            return ImageSetApi;
    }
}

export async function AddCategory(userContext:UserContext,type:SetType,name:string,onComplete:(data:any)=>void,onError?:(error:any)=>void){
 
    //update with the id "0" to create a new category
    await UpdateCategory(userContext,type,"0",name,onComplete,onError);

}

export async function UpdateCategory(userContext:UserContext,type:SetType,id:string,name:string,onComplete:(data:any)=>void,onError?:(error:any)=>void){
    await ValidateToken(userContext);
    let api = GetSetApi(type);

    let url = api.addEditCategory;

    let data = {
        Id:id,
        Name:name,
        UserID:userContext.userId
    }

    await AsyncAjaxPost(url,JSON.stringify(data),userContext.accessToken,onComplete,onError);

}

export async function GetAllBusinessTypes(userContext:UserContext,onComplete:(data:any)=>void,onError?:(error:any)=>void){
    const url = "style/getbusinesstype";
    await ValidateToken(userContext);
    await AsyncAjaxGet(url,userContext.accessToken,onComplete,onError);

}


export async function AssembleSiteStylingFromSets(userContext:UserContext,
    fontId:string,
    colorId:string,
    imageId:string,
    onComplete:(data:any)=>void,onError?:(error:any)=>void){

    await ValidateToken(userContext);

    const Ids = [fontId,colorId,imageId]
    const types = [SetType.Font,SetType.Color,SetType.Image]

    const result  = {
        data:[null,null,null],
        errored:false
    }

    for(let i = 0;i<types.length;i++){
        await GetSetItemDetails(userContext,types[i],Ids[i],(data)=>{

            console.log(data);
            try{


            if(data?.data?.data?.content)
                result.data[i] = JSON.parse(data.data.data.content);
            else
                result.errored = true;
            }
            catch{
                result.errored = true;
            }

        },(error)=>{
            result.errored = true;
          
        })
    }

    if(result.errored){
        onError?.(result);
    }

    let styling = {...DefaultSiteData.siteStyling};

    let fontData = result.data[0]??["proxima-nova","proxima-nova"];
    let colorData = result.data[1]??DefaultSiteData.siteStyling.colorPallet;
    let imageData = result.data[2]??DefaultSiteData.siteStyling.imageMapping;

    styling.fontPrimary = fontData[0];
    styling.fontSecondary = fontData[1];
    for(let i = 0;i<colorData.length;i++){ // since we need to keep the default darker colors update the array instead of replacing
        styling.colorPallet[i] = colorData[i];
    }
    styling.imageMapping = imageData;

    //default btn styling
    const btns = [styling.buttonPrimary,styling.buttonSecondary,styling.buttonTertiary];
    for(let i = 0;i<btns.length;i++){
        setNodeStyleAttributeValue(btns[i],0,"borderRaidus","5px");
    }

    onComplete(styling);

}

export async function GetSetList(userContext:UserContext,type:SetType,filters:string, onComplete:(data:any)=>void,onError?:(error:any)=>void,bid:number = 0){
    await ValidateToken(userContext);
    let api = GetSetApi(type);

    let url = api.getList;

    let data = {
        CategoryId:filters,
        MerchantId:bid

    }

    await AsyncAjaxPost(url,JSON.stringify(data),userContext.accessToken,onComplete,onError);

}

export async function GetBusinessCategoriesWithDefaults(userContext:UserContext,onComplete:(data:any)=>void,onError?:(error:any)=>void){

    await ValidateToken(userContext);

    const url = "style/stylecategorysubcategory";

    const Requestdata = {
        StyleId: "",
        CatagoryId: "",
        MerchantId: userContext.businessId

   };
   await AsyncAjaxPost(
        url,
        Requestdata,
        userContext.accessToken,
        function onSuccess(data:any) {

            onComplete(data);
        },
        function onError(error:any) {
            if(onError)
                onError(error);
        }
    );
}

export async function AddSetItem(userContext:UserContext,type:SetType,content:string[],categoryIds:string[],onComplete:(data:any)=>void,onError?:(error:any)=>void){
    await ValidateToken(userContext);
    let api = GetSetApi(type);

    let url = api.add;

    let data = {
        Content: JSON.stringify(content),
        CategoryId:categoryIds,
        Created_by:userContext.userId
    }

    await AsyncAjaxPost(url,JSON.stringify(data),userContext.accessToken,onComplete,onError);

}

export async function EditSetItemCategories(userContext:UserContext,type:SetType,id:string,categoryIds:string[],onComplete:(data:any)=>void,onError?:(error:any)=>void){
    await ValidateToken(userContext);
    let api = GetSetApi(type);

    let url = api.editItemsCategories;

    let data = {
        Id:id,
        CategoryId:categoryIds,
        Modified_by:userContext.userId
    }

    await AsyncAjaxPost(url,JSON.stringify(data),userContext.accessToken,onComplete,onError);

}

export async function EditSetItem(userContext:UserContext,type:SetType,id:string,content:string[],onComplete:(data:any)=>void,onError?:(error:any)=>void){
    await ValidateToken(userContext);
    let api = GetSetApi(type);

    let url = api.edit;

    let data = {
        Id:id,
        Content:JSON.stringify(content),
        Modified_by:userContext.userId
    }

    await AsyncAjaxPost(url,JSON.stringify(data),userContext.accessToken,onComplete,onError);

}

export async function ChangeSetSequence (userContext:UserContext,type:SetType,id:string,fromRank:number,toRank:number,  onComplete:(data:any)=>void,onError?:(error:any)=>void){
    await ValidateToken(userContext);
    let api = GetSetApi(type);

    let url = api.changeSequence;

    let data = {
        [`Source${type}Rank`]:fromRank,
        [`Destination${type}Rank`]:toRank,
        [`${type}Id`]:id,
        Modified_by:userContext.userId
    }

    await AsyncAjaxPost(url,JSON.stringify(data),userContext.accessToken,onComplete,onError);
}

export async function GetSetCategories(userContext:UserContext,type:SetType,onComplete:(data:any)=>void,onError?:(error:any)=>void){

    if(type == SetType.Image){
        await GetAllBusinessTypes(userContext,onComplete,onError);
        return;
    }

    await ValidateToken(userContext);
    let api = GetSetApi(type);

    let url = api.getCategories;

    await AsyncAjaxGet(url,userContext.accessToken,onComplete,onError);


}

export async function DeleteSetCategory(userContext:UserContext,type:SetType,id:string,onComplete:(data:any)=>void,onError?:(error:any)=>void){
    await ValidateToken(userContext);
    let api = GetSetApi(type);

    let url = api.deleteCategory + `?categoryId=${id}&UserID=${userContext.userId}`;

    await AsyncAjaxDelete(url,userContext.accessToken,onComplete,onError);


}

export async function AddSetCategory(userContext:UserContext,type:SetType,name:string,onComplete:(data:any)=>void,onError?:(error:any)=>void){

    await EditSetCategory(userContext,type,"0",name,onComplete,onError);
}

export async function EditSetCategory(userContext:UserContext,type:SetType,id:string,name:string,onComplete:(data:any)=>void,onError?:(error:any)=>void){
    await ValidateToken(userContext);
    let api = GetSetApi(type);

    let url = api.addEditCategory;

    let data = {
        Id:id,
        Name:name,
        UserID:userContext.userId
    }

    await AsyncAjaxPost(url,JSON.stringify(data),userContext.accessToken,onComplete,onError);

}

export async function GetSetItemDetails(userContext:UserContext,type:SetType,id:string,onComplete:(data:any)=>void,onError?:(error:any)=>void){

    await ValidateToken(userContext);
    let api = GetSetApi(type);

    let url = api.getDetails + id;

    await AsyncAjaxGet(url,userContext.accessToken,onComplete,onError);


}

export async function DeleteSetItem(userContext:UserContext,type:SetType,id:string,onComplete:(data:any)=>void,onError?:(error:any)=>void){
    await ValidateToken(userContext);
    let api = GetSetApi(type);

    let url = api.delete;

    let data = {
        Id:id,
        Modified_by:userContext.userId
    }

    await AsyncAjaxPost(url,JSON.stringify(data),userContext.accessToken,onComplete,onError);

}

export async function SetSetItemPublicOrPrivate(userContext:UserContext,type:SetType,isPublic:boolean, id:string,onComplete:(data:any)=>void,onError?:(error:any)=>void){
    await ValidateToken(userContext);
    let api = GetSetApi(type);

    let url = (isPublic)? api.setPublic:api.setPrivate;

    let data = {
        Id:id,
        Modified_by:userContext.userId
    }

    await AsyncAjaxPost(url,JSON.stringify(data),userContext.accessToken,onComplete,onError);

}





